import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageFilter from 'components/ui/filters/PageFilter';
import { ApplicationState } from 'store/rootReducer';
import { getMarFileListThunk, setFilterAction } from 'store/marFiles/marFilesActions';
import MarFilesList from 'views/AssetCatalog/MarFiles/MarsTable/MarFilesList';

class MarFiles extends Component<AllProps> {
  componentDidMount() {
    this.props.getMarFileList();
  }

  onFilterChange = () => {
    //default implementation does nothing
  };

  setOnFilterChange = (onFilterChange: any) => {
    this.onFilterChange = onFilterChange;
  };

  componentDidUpdate(prevProps: Readonly<AllProps>): void {
    //Do reload if page filter changes
    if (
      this.props.pageFilter.serviceId !== prevProps.pageFilter.serviceId ||
      this.props.pageFilter.searchTerm !== prevProps.pageFilter.searchTerm
    ) {
      this.props.getMarFileList();
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={'card'}>
          <div className={'card-body'}>
            <PageFilter setFilter={this.onFilterChange} context={'assets'} />
            <hr />
            <MarFilesList onFilterChange={this.setOnFilterChange} data={this.props.dataList} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => {
  return {
    pageFilter: state.ui.pageFilter,
    services: state.services.services,
    dataList: state.marFiles.dataList,
  };
};

const mapDispatchToProps = {
  getMarFileList: getMarFileListThunk,
  setFilterAction,
};

type MapStateToProps = ReturnType<typeof mapStateToProps>;
type MapDispatchToProps = typeof mapDispatchToProps;
type AllProps = MapStateToProps & MapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(MarFiles);
